export const CLIENT_STATE_UPDATE = 'CLIENT_STATE_UPDATE';
export const UPDATE_INSTRUCTION_REQUEST = 'UPDATE_INSTRUCTION_REQUEST';
